import moment from 'moment'

export default {
  speakers: [{
      "name": "Ed Roman",
      "title": "Managing Director, Hack VC, hack.summit() founder",
      "description": "Opening remarks, introducing hack.summit()",
      "picture": "ed-roman.png",
      "event": {
        "label": moment("2018-07-09T09:00:00-07:00").format("MMMM Do YYYY, h:mm A"),
        "title": "Ed Roman @ hack.summit()",
        "description": "Opening remarks, introducing hack.summit()",
        "location": "https://hacksummit.org",
        "startTime": "2018-07-09T09:00:00-07:00",
        "endTime": "2018-07-09T10:00:00-07:00"
      }
    },
    {
      "name": `Riccardo "Fluffy Pony" Spagni`,
      "title": "Lead Maintainer, Monero",
      "description": "Fireside chat",
      "picture": "fluffy.png",
      "event": {
        "label": moment("2018-07-10T09:00:00-07:00").format("MMMM Do YYYY, h:mm A"),
        "title": "Fluffy Pony @ HackSummit",
        "description": "Fireside chat",
        "location": "https://hacksummit.org",
        "startTime": "2018-07-10T09:00:00-07:00",
        "endTime": "2018-07-10T10:00:00-07:00"
      }
    },
    {
      "name": "Jed McCaleb",
      "title": "Co-founder of Ripple, Stellar, MtGox",
      "description": "Fireside chat",
      "picture": "jed.png",
      "event": {
        "label": moment("2018-07-09T09:30:00-07:00").format("MMMM Do YYYY, h:mm A"),
        "title": "Jed McCaleb @ HackSummit",
        "description": "Fireside chat",
        "location": "https://hacksummit.org",
        "startTime": "2018-07-09T09:30:00-07:00",
        "endTime": "2018-07-09T11:00:00-07:00"
      }
    },
    {
      "name": "Dominic Williams",
      "title": "CEO, DFINITY",
      "description": "A New Technology Stack? introducing the Internet Computer",
      "picture": "dominic.png",
      "event": {
        "label": moment("2018-07-11T12:00:00-07:00").format("MMMM Do YYYY, h:mm A"),
        "title": "Dominic Williams @ HackSummit",
        "description": "DFINITY Presentation",
        "location": "https://hacksummit.org",
        "startTime": "2018-07-11T12:00:00-07:00",
        "endTime": "2018-07-11T13:00:00-07:00"
      }
    },
    {
      "name": "Nader Al-Naji",
      "title": "CEO of Basis (Formerly Basecoin)",
      "description": "Engineering an Algorithmic Central Bank",
      "picture": "nader.png",
      "event": {
        "label": moment("2018-07-10T10:00:00-07:00").format("MMMM Do YYYY, h:mm A"),
        "title": "Nader Al-Naji @ HackSummit",
        "description": "Engineering an Algorithmic Central Bank",
        "location": "https://hacksummit.org",
        "startTime": "2018-07-10T10:00:00-07:00",
        "endTime": "2018-07-10T11:00:00-07:00"
      }
    },
    {
      "name": "Eli Ben-Sasson",
      "title": "ZCash founding scientist, co-inventor of zk-SNARKs, co-founder of Starkware",
      "description": "STARKs -- transparent scalability and privacy",
      "picture": "eliben.png",
      "event": {
        "label": moment("2018-07-11T10:00:00-07:00").format("MMMM Do YYYY, h:mm A"),
        "title": "Eli Ben-Sasson @ HackSummit",
        "description": "STARKs -- transparent scalability and privacy",
        "location": "https://hacksummit.org",
        "startTime": "2018-07-11T10:00:00-07:00",
        "endTime": "2018-07-11T11:00:00-07:00"
      }
    },
    {
      "name": "Jutta Steiner",
      "title": "Co-Founder and CEO, Parity Technologies.  Former CSO, Ethereum Foundation",
      "description": "Parity Technologies Presentation",
      "picture": "jutta.png",
      "event": {
        "label": moment("2018-07-11T11:00:00-07:00").format("MMMM Do YYYY, h:mm A"),
        "title": "Jutta Steiner @ HackSummit",
        "description": "Parity Technologies Presentation",
        "location": "https://hacksummit.org",
        "startTime": "2018-07-11T11:00:00-07:00",
        "endTime": "2018-07-11T12:00:00-07:00"
      }
    },
    {
      "name": "Leemon Baird",
      "title": "Founder and Chief Scientist, Hedera Hashgraph",
      "description": "What is Byzantine Fault Tolerance?",
      "picture": "leemon.png",
      "event": {
        "label": moment("2018-07-09T15:00:00-07:00").format("MMMM Do YYYY, h:mm A"),
        "title": "Leemon Baird @ HackSummit",
        "description": "What is Byzantine Fault Tolerance?",
        "location": "https://hacksummit.org",
        "startTime": "2018-07-09T15:00:00-07:00",
        "endTime": "2018-07-09T16:00:00-07:00"
      }
    },
    {
      "name": "Brian Fox",
      "title": "Co-Founder, Orchid Protocol",
      "description": "Fireside chat",
      "picture": "brian-fox.png",
      "event": {
        "label": moment("2018-07-09T11:00:00-07:00").format("MMMM Do YYYY, h:mm A"),
        "title": "Brian Fox @ HackSummit",
        "description": "Fireside chat",
        "location": "https://hacksummit.org",
        "startTime": "2018-07-09T11:00:00-07:00",
        "endTime": "2018-07-09T12:00:00-07:00"
      }
    },
    {
      "name": "Dawn Song",
      "title": "Co-founder and CEO of Oasis Labs",
      "description": "Privacy-preserving Smart Contract at Scale",
      "picture": "dawn.png",
      "event": {
        "label": moment("2018-07-10T11:00:00-07:00").format("MMMM Do YYYY, h:mm A"),
        "title": "Dawn Song @ HackSummit",
        "description": "Oasis Labs Presentation",
        "location": "https://hacksummit.org",
        "startTime": "2018-07-10T11:00:00-07:00",
        "endTime": "2018-07-10T12:00:00-07:00"
      }
    },
    {
      "name": "Brian Behlendorf",
      "title": "Executive Director, Hyperledger",
      "description": "Blockchains Beyond Cryptocurrecy: Trust As A Service",
      "picture": "brianb.png",
      "event": {
        "label": moment("2018-07-11T09:00:00-07:00").format("MMMM Do YYYY, h:mm A"),
        "title": "Brian Behlendorf @ HackSummit",
        "description": "Blockchains Beyond Cryptocurrecy: Trust As A Service",
        "location": "https://hacksummit.org",
        "startTime": "2018-07-11T09:00:00-07:00",
        "endTime": "2018-07-11T10:00:00-07:00"
      }
    },
    {
      "name": "Elaine Shi",
      "title": "Co-founder & Chief Scientist, Thunder Token",
      "description": "Toward a Secured, Scalable and Fast High Performance Blockchain",
      "picture": "elaine.png",
      "event": {
        "label": moment("2018-07-10T17:00:00-07:00").format("MMMM Do YYYY, h:mm A"),
        "title": "Elaine Shi @ HackSummit",
        "description": "Thunder Token Presentation",
        "location": "https://hacksummit.org",
        "startTime": "2018-07-10T17:00:00-07:00",
        "endTime": "2018-07-10T18:00:00-07:00"
      }
    },
    {
      "name": "Benny Giang",
      "title": "Co-founder, CryptoKitties ",
      "description": "How to bring the first billion consumers to the blockchain",
      "picture": "benny.png",
      "event": {
        "label": moment("2018-07-09T13:00:00-07:00").format("MMMM Do YYYY, h:mm A"),
        "title": "Benny Giang @ HackSummit",
        "description": "Cryptokitties Presentation",
        "location": "https://hacksummit.org",
        "startTime": "2018-07-09T13:00:00-07:00",
        "endTime": "2018-07-09T14:00:00-07:00"
      }
    },
    {
      "name": "William Martino",
      "title": "CEO, Kadena",
      "description": "Understanding the History and Function of Consensus",
      "picture": "william.png",
      "event": {
        "label": moment("2018-07-10T13:00:00-07:00").format("MMMM Do YYYY, h:mm A"),
        "title": "William Martino @ HackSummit",
        "description": "Understanding the History and Function of Consensus",
        "location": "https://hacksummit.org",
        "startTime": "2018-07-10T13:00:00-07:00",
        "endTime": "2018-07-10T14:00:00-07:00"
      }
    },
    {
      "name": "Paul Veradittakit",
      "title": "Partner, Pantera Capital",
      "description": "Investor panel",
      "picture": "paul.png",
      "event": {
        "label": moment("2018-07-09T12:00:00-07:00").format("MMMM Do YYYY, h:mm A"),
        "title": "Paul Veradittakit @ HackSummit",
        "description": "Investor panel",
        "location": "https://hacksummit.org",
        "startTime": "2018-07-09T12:00:00-07:00",
        "endTime": "2018-07-09T13:00:00-07:00"
      }
    },
    {
      "name": "Rafael Cosman",
      "title": "Co-Founder and CTO, TrustToken",
      "description": "Fireside chat",
      "picture": "rafael.png",
      "event": {
        "label": moment("2018-07-09T14:00:00-07:00").format("MMMM Do YYYY, h:mm A"),
        "title": "Rafael Cosman @ HackSummit",
        "description": "Fireside chat",
        "location": "https://hacksummit.org",
        "startTime": "2018-07-09T14:00:00-07:00",
        "endTime": "2018-07-09T15:00:00-07:00"
      }
    },
    {
      "name": "Cindy Cheng",
      "title": "Investor, Vy Capital",
      "description": "Investor panel",
      "picture": "cindy.png",
      "event": {
        "label": moment("2018-07-09T12:00:00-07:00").format("MMMM Do YYYY, h:mm A"),
        "title": "Cindy Cheng @ HackSummit",
        "description": "Investor panel",
        "location": "https://hacksummit.org",
        "startTime": "2018-07-09T12:00:00-07:00",
        "endTime": "2018-07-09T13:00:00-07:00"
      }
    },
    {
      "name": "Josh Fraser",
      "title": "Co-Founder, 0rigin Protocol",
      "description": "Building decentralized marketplaces on the blockchain",
      "picture": "josh.png",
      "event": {
        "label": moment("2018-07-10T15:00:00-07:00").format("MMMM Do YYYY, h:mm A"),
        "title": "Josh Fraser @ HackSummit",
        "description": "Opening remarks for HackSummit",
        "location": "https://hacksummit.org",
        "startTime": "2018-07-10T15:00:00-07:00",
        "endTime": "2018-07-10T15:30:00-07:00"
      }
    },
    {
      "name": "Kyle Samani",
      "title": "Managing Partner, Multicoin Capital",
      "description": "Investor panel",
      "picture": "kyle.png",
      "event": {
        "label": moment("2018-07-09T12:00:00-07:00").format("MMMM Do YYYY, h:mm A"),
        "title": "Kyle Samani @ HackSummit",
        "description": "Investor panel",
        "location": "https://hacksummit.org",
        "startTime": "2018-07-09T12:00:00-07:00",
        "endTime": "2018-07-09T13:00:00-07:00"
      }
    },
    {
      "name": "Monica Quaintance",
      "title": "Engineering Lead, Kadena",
      "description": "Understanding the History and Function of Consensus",
      "picture": "monica.png",
      "event": {
        "label": moment("2018-07-10T13:00:00-07:00").format("MMMM Do YYYY, h:mm A"),
        "title": "Monica Quaintance @ HackSummit",
        "description": "Understanding the History and Function of Consensus",
        "location": "https://hacksummit.org",
        "startTime": "2018-07-10T13:00:00-07:00",
        "endTime": "2018-07-10T14:00:00-07:00"
      }
    },
    {
      "name": "MacLane Wilkison",
      "title": "CEO, NuCypher",
      "description": "A Survey of Privacy-Preserving Technologies for Blockchains",
      "picture": "maclane.png",
      "event": {
        "label": moment("2018-07-10T14:00:00-07:00").format("MMMM Do YYYY, h:mm A"),
        "title": "Monica Quaintance @ HackSummit",
        "description": "A Survey of Privacy-Preserving Technologies for Blockchains",
        "location": "https://hacksummit.org",
        "startTime": "2018-07-10T14:00:00-07:00",
        "endTime": "2018-07-10T15:00:00-07:00"
      }
    },
    {
      "name": "Caroline Kassie",
      "title": "Partner, Blockchange Capital",
      "description": "Investor panel",
      "picture": "caroline.png",
      "event": {
        "label": moment("2018-07-09T12:00:00-07:00").format("MMMM Do YYYY, h:mm A"),
        "title": "Caroline Kassie @ HackSummit",
        "description": "Investor panel",
        "location": "https://hacksummit.org",
        "startTime": "2018-07-09T12:00:00-07:00",
        "endTime": "2018-07-09T13:00:00-07:00"
      }
    },
    {
      "name": "Weiting Liu",
      "title": "CEO, Codementor & Dev Protocol",
      "description": "Building Decentralized Ecosystems",
      "picture": "weiting.png",
      "event": {
        "label": moment("2018-07-11T15:30:00-07:00").format("MMMM Do YYYY, h:mm A"),
        "title": "Weiting Liu @ HackSummit",
        "description": "Building Decentralized Ecosystems",
        "location": "https://hacksummit.org",
        "startTime": "2018-07-11T15:30:00-07:00",
        "endTime": "2018-07-11T16:00:00-07:00"
      }
    },
    {
      "name": "Antonio Salazar Cardozo",
      "title": "Technical Lead, Keep Network",
      "description": "Building software in a fast-changing ecosystem",
      "picture": "antonio.png",
      "event": {
        "label": moment("2018-07-11T13:00:00-07:00").format("MMMM Do YYYY, h:mm A"),
        "title": "Antonio Salazar Cardozo @ HackSummit",
        "description": "Use Your Pockets: Building software in a fast-changing ecosystem",
        "location": "https://hacksummit.org",
        "startTime": "2018-07-11T13:00:00-07:00",
        "endTime": "2018-07-11T14:00:00-07:00"
      }
    },
    {
      "name": "Olaf Carlson-Wee",
      "title": "Founder and CEO, Polychain Capital",
      "description": "Fireside chat",
      "picture": "olaf.png",
      "event": {
        "label": moment("2018-07-10T16:00:00-07:00").format("MMMM Do YYYY, h:mm A"),
        "title": "Olaf Carlson-Wee @ HackSummit",
        "description": "Fireside chat",
        "location": "https://hacksummit.org",
        "startTime": "2018-07-10T16:00:00-07:00",
        "endTime": "2018-07-10T17:00:00-07:00"
      }
    },
    {
      "name": "Tammy Camp",
      "title": "CEO, Stronghold. Former Head of Growth, Stellar",
      "description": "Liquidity, Regulation, and Exchanges",
      "picture": "tammy.png",
      "event": {
        "label": moment("2018-07-10T15:30:00-07:00").format("MMMM Do YYYY, h:mm A"),
        "title": "Tammy Camp @ HackSummit",
        "description": "Liquidity, Regulation, and Exchanges",
        "location": "https://hacksummit.org",
        "startTime": "2018-07-10T15:30:00-07:00",
        "endTime": "2018-07-10T16:00:00-07:00"
      }
    },
    {
      "name": "Sean Bennett",
      "title": "CTO, Stronghold",
      "description": "Liquidity, Regulation, and Exchanges",
      "picture": "sean.png",
      "event": {
        "label": moment("2018-07-10T15:30:00-07:00").format("MMMM Do YYYY, h:mm A"),
        "title": "Sean Bennett @ HackSummit",
        "description": "Liquidity, Regulation, and Exchanges",
        "location": "https://hacksummit.org",
        "startTime": "2018-07-10T15:30:00-07:00",
        "endTime": "2018-07-10T16:00:00-07:00"
      }
    },
    {
      "name": "Izaak Meckler",
      "title": "Co-Founder and CTO, Coda Protocol",
      "description": "Using zk-SNARKs to create a blockless blockchain",
      "picture": "izaak.png",
      "event": {
        "label": moment("2018-07-11T15:00:00-07:00").format("MMMM Do YYYY, h:mm A"),
        "title": "Izaak Meckler @ HackSummit",
        "description": "Using zk-SNARKs to create a blockless blockchain",
        "location": "https://hacksummit.org",
        "startTime": "2018-07-11T15:00:00-07:00",
        "endTime": "2018-07-11T15:30:00-07:00"
      }
    },
    {
      "name": "Kristoffer Josefsson",
      "title": "Co-Founder and CTO, FOAM Protocol",
      "description": "Applying the Functional web3 Stack to dApp Development",
      "picture": "kristoffer.png",
      "event": {
        "label": moment("2018-07-11T14:00:00-07:00").format("MMMM Do YYYY, h:mm A"),
        "title": "Kristoffer Josefsson @ HackSummit",
        "description": "Applying the Functional web3 Stack to dApp Development",
        "location": "https://hacksummit.org",
        "startTime": "2018-07-11T14:00:00-07:00",
        "endTime": "2018-07-11T15:00:00-07:00"
      }
    },
    {
      "name": "Stan Kladko",
      "title": "Co-Founder and CTO, SKALE Labs",
      "description": "Introduction to Asynchronous Consensus Protocols",
      "picture": "stan.png",
      "event": {
        "label": moment("2018-07-11T13:30:00-07:00").format("MMMM Do YYYY, h:mm A"),
        "title": "Stan Kladko @ HackSummit",
        "description": "Introduction to Asynchronous Consensus Protocols",
        "location": "https://hacksummit.org",
        "startTime": "2018-07-11T13:30:00-07:00",
        "endTime": "2018-07-11T14:00:00-07:00"
      }
    },
    {
      "name": `Kapil "KK" Jain`,
      "title": "Founder and Lead Developer, nCent Labs",
      "description": "Fireside Chat",
      "picture": "kapil.png",
      "event": {
        "label": moment("2018-07-10T12:00:00-07:00").format("MMMM Do YYYY, h:mm A"),
        "title": "Kapil Jain @ HackSummit",
        "description": "Fireside Chat",
        "location": "https://hacksummit.org",
        "startTime": "2018-07-10T12:00:00-07:00",
        "endTime": "2018-07-10T13:00:00-07:00"
      }
    },
    {
      "name": `Mark Lurie`,
      "title": "CEO, Codex Protocol",
      "description": "Fireside chat",
      "picture": "mark.png",
      "event": {
        "label": moment("2018-07-09T16:00:00-07:00").format("MMMM Do YYYY, h:mm A"),
        "title": "John Piotrowski @ HackSummit",
        "description": "De-centralized Exchange Panel",
        "location": "https://hacksummit.org",
        "startTime": "2018-07-09T16:00:00-07:00",
        "endTime": "2018-07-09T17:00:00-07:00"
      }
    },
    {
      "name": `Group session`,
      "title": "De-centralized Exchange Panel",
      "description": "Presented by Alan Curtis(Radar Relay) and John Piotrowski(The Ocean)",
      "picture": "decentralized.png",
      "event": {
        "label": moment("2018-07-09T16:00:00-07:00").format("MMMM Do YYYY, h:mm A"),
        "title": "De-centralized Exchange Panel @ HackSummit",
        "description": "Presented by Alan Curtis(Radar Relay) and John Piotrowski(The Ocean)",
        "location": "https://hacksummit.org",
        "startTime": "2018-07-09T16:00:00-07:00",
        "endTime": "2018-07-09T17:00:00-07:00"
      }
    },
    {
      "name": `Group session`,
      "title": "Tech Infrastructure for Cryptographic games",
      "description": "Presented by Allen Hsu, Robbie Ferguson, Aleksander Larsen and Viktor Radchenko",
      "picture": "gamepanel.png",
      "event": {
        "label": moment("2018-07-09T17:00:00-07:00").format("MMMM Do YYYY, h:mm A"),
        "title": "Tech Infrastructure for Cryptographic games @ HackSummit",
        "description": "Tech Infrastructure for Cryptographic games",
        "location": "https://hacksummit.org",
        "startTime": "2018-07-09T17:00:00-07:00",
        "endTime": "2018-07-09T18:00:00-07:00"
      }
    }
  ],
  nonprofits: [
    {
      "name": "Women Who Code",
      "url": "https://www.womenwhocode.com/",
      "logo": "women-who-code.png"
    },{
    
      "name": "Black Girls Code",
      "url": "http://www.blackgirlscode.com/",
      "logo": "black-girls-code.png"
    },
    {
      "name": "Girls Who Code",
      "url": "https://girlswhocode.com/",
      "logo": "girls-who-code.png"
    },
    {
      "name": "Free Code Camp",
      "url": "https://www.freecodecamp.org/",
      "logo": "freecodecamp.png"
    },
    {
      "name": "Coder Dojo",
      "url": "https://coderdojo.org",
      "logo": "coderdojo.png"
    },
    {
      "name": "Bridge Foundry",
      "url": "https://bridgefoundry.org/",
      "logo": "bridge-foundry.png"
    },
    {
      "name": "Eff",
      "url": "https://eff.org/",
      "logo": "eff.png"
    }
  ],
  partners: [
    {
      "name": "Pluralsight",
      "url": "https://www.pluralsight.com",
      "logo": "pluralsight.png"
    },
    {
      "name": "Dev Protocol",
      "url": "https://www.devprotocol.io/",
      "logo": "devprotocol.png"
    },
    {
      "name": "Dfinity",
      "url": "https://dfinity.org/",
      "logo": "dfinity.png"
    },
    {
      "name": "Crowdcast",
      "url": "https://crowdcast.io",
      "logo": "crowdcast.png"
    },
    {
      "name": "Orchid",
      "url": "https://www.orchid.com/",
      "logo": "orchid.png"
    },
    {
      "name": "HyperLedger",
      "url": "https://www.hyperledger.org/",
      "logo": "hyperledger.png"
    },
    {
      "name": "CryptoKitties",
      "url": "https://www.cryptokitties.co/",
      "logo": "kitties.png"
    },
    {
      "name": "HashGraph",
      "url": "https://www.hederahashgraph.com",
      "logo": "hashgraph.png"
    },
    {
      "name": "Nucypher",
      "url": "https://www.nucypher.com/",
      "logo": "nucypher.png"
    },
    {
      "name": "Origin",
      "url": "https://www.originprotocol.com/en",
      "logo": "origin.png"
    },
    {
      "name": "Topcoder",
      "url": "https://topcoder.com",
      "logo": "topcoder.png"
    },
    {
      "name": "Kadena",
      "url": "http://kadena.io",
      "logo": "kadena.png"
    },
    {
      "name": "Thunder",
      "url": "https://www.thundertoken.com/",
      "logo": "thunder.png"
    },
    {
      "name": "Hired",
      "url": "https://hired.com",
      "logo": "hired.png"
    },
    {
      "name": "Multicoin",
      "url": "https://multicoin.capital",
      "logo": "multicoin.png"
    },
    {
      "name": "Toptal",
      "url": "https://toptal.com",
      "logo": "toptal.png"
    },
    {
      "name": "Keep",
      "url": "https://keep.network",
      "logo": "keep.png"
    },
    {
      "name": "GeneralAssembly",
      "url": "https://generalassemb.ly",
      "logo": "ga.png"
    },
    {
      "name": "Infoq",
      "url": "https://infoq.com",
      "logo": "infoq.png"
    },
    {
      "name": "Hackerrank",
      "url": "hackerrank.com",
      "logo": "hackerrank.png"
    },
    {
      "name": "Stronghold",
      "url": "https://stronghold.co",
      "logo": "stronghold.png"
    },
    {
      "name": "Joseph",
      "url": "https://josephsteinberg.com/",
      "logo": "joseph.png"
    },
    {
      "name": "CodeAnywhere",
      "url": "https://codeanywhere.com/",
      "logo": "codeanywhere.png"
    },
    {
      "name": "Codewars",
      "url": "https://www.codewars.com/",
      "logo": "codewars.png"
    }
  ],
  hackathon: [{
    "name": "Bluzelle",
    "url": "https://bluzelle.com/",
    "logo": "bluzelle-white.png"
  },
  {
    "name": "Elastos",
    "url": "https://www.elastos.org",
    "logo": "elastos-white.png"
  },
  {
    "name": "Mobius",
    "url": "https://mobius.network/",
    "logo": "mobius-white.png"
  },
  {
    "name": "Nucypher",
    "url": "https://www.nucypher.com/",
    "logo": "nu.png"
  },
  {
    "name": "Komodo",
    "url": "https://komodoplatform.com/",
    "logo": "komodo.png"
  },
  {
    "name": "Mixin",
    "url": "https://mixin.one/",
    "logo": "mixin.png"
  },
  {
    "name": "Torque",
    "url": "https://www.torque.vc/",
    "logo": "torque.png"
  },
  {
    "name": "Aragon",
    "url": "https://aragon.one/",
    "logo": "aragon.png"
  },
  {
    "name": "Wanchain",
    "url": "https://wanchain.org/",
    "logo": "wanchain.png"
  },
  {
    "name": "Dispatch Labs",
    "url": "https://dispatchlabs.io/",
    "logo": "dispatch.png"
  },
  {
    "name": "ConsenSys",
    "url": "https://new.consensys.net/",
    "logo": "consensys.png"
  },
  {
    "name": "Havven",
    "url": "https://havven.io/",
    "logo": "havven.png"
  },
  {
    "name": "Datum",
    "url": "https://datum.org/",
    "logo": "datum.png"
  },
  {
    "name": "Humaniq",
    "url": "https://humaniq.com/",
    "logo": "humaniq.png"
  },
  {
    "name": "Aeternity",
    "url": "https://aeternity.com/",
    "logo": "aeternity.png"
  },
  {
    "name": "MakerDao",
    "url": "https://makerdao.com/",
    "logo": "makerdao.png"
  },
  {
    "name": "Apla",
    "url": "https://apla.io/",
    "logo": "apla.png"
  },
  {
    "name": "Restart energy",
    "url": "https://restartenergy.io/",
    "logo": "restart.png"
  },
  {
    "name": "BankEx",
    "url": "https://bankexfoundation.org/",
    "logo": "bankex.png"
  }
]
}


// WEBPACK FOOTER //
// ./src/components/assets/data/index.js